exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body-sm .modal .modal-body{padding-top:1.5rem;padding-bottom:1.5rem}", ""]);

// exports
